import { useContext } from "react";

import { SnackbarContext } from "../providers/SnackbarProvider";

const useSnackbar = () => {
  return useContext(SnackbarContext);
};

export default useSnackbar;
